import { Team, TeamStatus } from '../../fes';

export type TeamPanelMode = 'read' | 'edit' | 'saving';

export type TeamFormState = {
  name: string;
  description: string;
  status: TeamStatus;
  installationId: string;
};

export const teamStatuses: TeamStatus[] = ['active', 'inactive', 'suspended'];

export const emptyTeamForm: TeamFormState = {
  name: '',
  description: '',
  status: 'active',
  installationId: '',
};

export function isTeamStatus(status: Team['status']): status is TeamStatus {
  return teamStatuses.includes(status as TeamStatus);
}

export function teamToForm(team: Team): TeamFormState {
  return {
    name: team.name || '',
    description: team.description || '',
    status: isTeamStatus(team.status) ? team.status : 'active',
    installationId: typeof team.installationId === 'number' ? String(team.installationId) : '',
  };
}

export function formatInstallationId(installationId: Team['installationId']): string {
  return typeof installationId === 'number' ? String(installationId) : '-';
}

export function formatArray(values: string[] | undefined): string {
  return values && values.length > 0 ? values.join('\n') : '-';
}

export function formatMetadataValue(value: string | undefined): string {
  return value || '-';
}
